import React, { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface StyledTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  containerStyles?: string;
  textareaStyles?: string;
}

const StyledTextarea = forwardRef<HTMLTextAreaElement, StyledTextareaProps>(
  ({ className, error, containerStyles, textareaStyles, ...props }, ref) => {
    return (
      <div className="w-full">
        <div
          className={cn(
            'rounded border-l-[2.4px] w-full overflow-hidden focus-within:border-primary',
            error ? 'border-red-500' : 'border-primary',
            containerStyles || 'mt-1',
            'bg-[#F6F9FF]'
          )}
        >
          <textarea
            ref={ref}
            className={cn(
              'px-5 py-3 text-[#5A5A5A] placeholder:text-[#5A5A5A] bg-[#F6F9FF] text-sm w-full outline-none resize-none',
              textareaStyles || 'min-h-[80px]',
              className
            )}
            {...props}
          />
        </div>
        {error && (
          <p className="text-red-500 text-sm mt-1 pl-2">{error}</p>
        )}
      </div>
    );
  }
);

StyledTextarea.displayName = 'StyledTextarea';

export { StyledTextarea };

